import { NewBuilding } from '@search/filter-enums/enums/NewBuilding';
import { SeoMapper } from '@search/router/src';

export const newBuildingMapper = new SeoMapper('newBuildingMapper', {
    new: NewBuilding.NEW,
    second: NewBuilding.SECOND,
    unknown: NewBuilding.UNKNOWN
} as const);
